import React, { useCallback, useEffect, useState } from 'react';
import useTextContents from '../../../hooks/useTextContents'
import { useDispatch, useSelector } from 'react-redux'
import { apphistory, AppState } from '../../../store'
import { IPredefinedSingleOfferResponse, ISubmitChooseOfferData, PREDEFINED_PERIODS_OFFER_LOGIC, PredefinedOfferNames } from '../../../store/types'
import analyticsService from '../../../service/analytics.service'
import { SET_APP_HAS_ERROR } from '../../../store/actions/application-actions'
import { RECALCULATE_OFFER, USER_CHANGE_CURRENT_LOAN_AMOUNT } from '../../../store/actions/offert-action'
import { AppLinks } from '../../../environment/app-links'
import { invokeLoadingWithText } from '../../../common/invokeLoading'
import offerService from '../../../service/OfferService'
import { IUsePredefinedOfferPageLogicReturnProps } from '../PredefinedOfferPageProps'



const usePredefinedOfferPageLogic = (props: { predefinedOffersData: IPredefinedSingleOfferResponse[] | undefined }): IUsePredefinedOfferPageLogicReturnProps => {

   const textContent = useTextContents()
   const dispatch = useDispatch()

   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)
   const { predefinedUserOffersArray, predefinedUserOffersObject, ...currentUserOffer} = useSelector((state: AppState) => state.offertState)
   const { IS_PREDEFINED_PERIODS_AVAILABLE } = useSelector((state: AppState) => state.applicationState)

   const { predefinedOffersData } = props

   const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
   const [currentSelectedOffer, setCurrentSelectedOffer] = useState<IPredefinedSingleOfferResponse | undefined>(undefined)
   const HAS_NO_OFFERS = predefinedOffersData === undefined || predefinedOffersData.length === 0

   const handleToggleMenuOpen =  useCallback(() => setIsMenuOpen(!isMenuOpen), [isMenuOpen])


   //!!! JEŚLI TABLICA Z PREDEFINIOWANYMI OFERTAMI JEST PUSTA WYŚWIETLAMY STRONĘ BŁĘDU
   useEffect(() => {
      if (!HAS_NO_OFFERS) {
         return
      }
    
      (async() => {
         try {
            const ERROR_ANALYTICS_DATA = {
               id: analyticsService.DISPLAY_ERROR_PAGE_IDS.PREDEFINED_USER_OFFER_EMPTY_ARRAY_SESSION_STORAGE_ERROR,
               reason: `Pusta tablica z predefiniowanymi ofertami po stronie Frontendu. Nie udało się jej pobrać ze stanu aplikacji (sessionStorage).`,
               details: {},
            }

            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
         } 
         finally {
            dispatch({ type: SET_APP_HAS_ERROR })
         }
      })()
    
   }, [ HAS_NO_OFFERS, ANALYTICS_EVENT_TYPES_NAMES, dispatch ])



   const handleOnOfferClick = async(selectedOfferId: number) => {
      if (HAS_NO_OFFERS) {
         return
      }

      setIsMenuOpen(true)
      const currentSelectedOfferFromArray = predefinedOffersData.find((offer: IPredefinedSingleOfferResponse) => offer.id === selectedOfferId)


      if(currentSelectedOfferFromArray === undefined) {
         return
      }
      else {
         const offerToSendForAnalyticsEvent = {
            id: currentSelectedOfferFromArray.id, name: currentSelectedOfferFromArray.name, requestedAmount: currentSelectedOfferFromArray.requestedAmount,
            instalments: currentSelectedOfferFromArray.instalments, isRecommended: currentSelectedOfferFromArray.isRecommended
         }

         setCurrentSelectedOffer(currentSelectedOfferFromArray)

         switch(currentSelectedOfferFromArray.name){
            case PredefinedOfferNames.REQUESTED_USER_OFFER: {
               await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.PredefinedOfferRequestedAmountOfferSelected, JSON.stringify(offerToSendForAnalyticsEvent, undefined, 3))

               break;
            }
            case PredefinedOfferNames.HIGHEST_OFFER: {
               await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.PredefinedOfferHighestOfferSelected, JSON.stringify(offerToSendForAnalyticsEvent, undefined, 3))

               break;
            }
            case PredefinedOfferNames.BONUS_OFFER: {
               await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.PredefinedOfferBonusOfferSelected, JSON.stringify(offerToSendForAnalyticsEvent, undefined, 3))

               break;
            }
         }
      }
   }


   const handleSubmitPredefinedOffer = async() => {
      if (HAS_NO_OFFERS) {
         return
      }

      if(currentSelectedOffer !== undefined) {
         const offerToSend: ISubmitChooseOfferData = { //Mapowanie oferty trzymanej po stronie Frontendu na model z Backendu
            offerId: currentSelectedOffer.offerId,
            instalments: currentSelectedOffer.instalments,
            requestedAmount: currentSelectedOffer.requestedAmount,
            instalmentsAmount: currentSelectedOffer.instalmentsAmount,
         }

         dispatch({
            type: USER_CHANGE_CURRENT_LOAN_AMOUNT,
            payload: currentSelectedOffer.requestedAmount
         })

         dispatch(invokeLoadingWithText(textContent('loaders.prepareAgreement')))


         // Przed wybraniem umowy robimy jeszcze jedno przeliczenie, żeby zaktualizować ofertę na mongo
         const recalculateOfferResponse = await offerService.recalculateOffer({
            offerId: currentSelectedOffer.offerId,
            instalments: currentSelectedOffer.instalments ?? 0,
            requestedAmount: currentSelectedOffer.requestedAmount,
         })

         // Aktualizujemy  stan ostatecznym przeliczeniem oferty
         dispatch({
            type: RECALCULATE_OFFER,
            payload: recalculateOfferResponse,
         })


         // =================== ZAPIS EVENTU ANALITYCZNEGO Z WYBOREM OFERTY ===================
            let additionalAgreementData: Record<string, any> | null = null


            if(IS_PREDEFINED_PERIODS_AVAILABLE === true && predefinedUserOffersObject !== undefined) {
               additionalAgreementData = {
                  userRequestedAmount: currentUserOffer.requestedAmount,
                  isPredefinedPeriodsLogicAvailable: true,
                  recommendedOffer: {
                     description: "Mechanizm predefiniowanych okresów spłaty, nie posiada rekomendowanych ofert"
                  },
                  selectedOffer: {
                     selectedOfferSource: "PREDEFINIOWANA OFERTA",
                     description: "Szczegóły oferty wybranej przez użytkownika",
                     offerId: currentSelectedOffer.offerId,
                     requestedAmount:  currentSelectedOffer.requestedAmount,
                     instalments: currentSelectedOffer.instalments,
                     instalmentsAmount: currentSelectedOffer.instalmentsAmount,
                     ckdz: currentSelectedOffer.ckdz,
                     interestRate: currentSelectedOffer.interestRate,
                  },
                  predefinedUserOffersArray: [
                     ...predefinedUserOffersObject[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD], 
                     ...predefinedUserOffersObject[PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD],
                  ]
               }
            }
            else if (IS_PREDEFINED_PERIODS_AVAILABLE === false && predefinedUserOffersArray !== undefined ) {
               additionalAgreementData = {
                  userRequestedAmount: currentUserOffer.requestedAmount,
                  isPredefinedPeriodsLogicAvailable: false,
                  recommendedOffer: {
                     description: "Szczegóły oferty rekomendowanej",
                     ...predefinedUserOffersArray.find(singleOffer => singleOffer.isRecommended === true)
                  },
                  selectedOffer: {
                     selectedOfferSource: "PREDEFINIOWANA OFERTA",
                     description: "Szczegóły oferty wybranej przez użytkownika",
                     offerId: currentSelectedOffer.offerId,
                     requestedAmount:  currentSelectedOffer.requestedAmount,
                     instalments: currentSelectedOffer.instalments,
                     instalmentsAmount: currentSelectedOffer.instalmentsAmount,
                     ckdz: currentSelectedOffer.ckdz,
                     interestRate: currentSelectedOffer.interestRate,
                  },
                  predefinedUserOffersArray: predefinedUserOffersArray.map(singleOffer => {
                     return {
                        id: singleOffer.id,
                        name: singleOffer.name,
                        requestedAmount: singleOffer.requestedAmount,
                        instalments: singleOffer.instalments,
                        instalmentsAmount: singleOffer.instalmentsAmount,
                        isRecommended: singleOffer.isRecommended
                     }
                  }).sort((a,b) => a.requestedAmount - b.requestedAmount), //Sortowanie rosnąco po kwocie oferty,
               }
            }

            if(additionalAgreementData !== null) {
               await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.UserSelectOffer, JSON.stringify(additionalAgreementData, undefined, 3))
            }
         // ================================================================================


         await offerService.chooseOffer(offerToSend)
      }
   }


   return {
      ANALYTICS_EVENT_TYPES_NAMES,
      currentSelectedOffer,
      isMenuOpen,
      
      handleToggleMenuOpen,
      handleOnOfferClick,
      handleSubmitPredefinedOffer,
   }

}

export default usePredefinedOfferPageLogic